export const isApp = () => !!window.isApp;

export function postBridgeMessage(type, payload) {
  if (window.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ type, payload }));
  }
}

function waitForEvent(eventName, timeoutMs = 10000) {
  return new Promise((resolve) => {
    const handler = (event) => {
      window.removeEventListener(eventName, handler);
      resolve(event.detail);
    };
    window.addEventListener(eventName, handler);
    setTimeout(() => {
      window.removeEventListener(eventName, handler);
      resolve(null);
    }, timeoutMs);
  });
}

export function requestPushToken() {
  const promise = waitForEvent('PUSH_TOKEN_RESULT');
  postBridgeMessage('REQUEST_PUSH_TOKEN');
  return promise;
}

export function requestLocation() {
  const promise = waitForEvent('LOCATION_RESULT');
  postBridgeMessage('REQUEST_LOCATION');
  return promise;
}

export function getAppInfo() {
  const promise = waitForEvent('APP_INFO_RESULT');
  postBridgeMessage('GET_APP_INFO');
  return promise;
}

export function requestCamera(source = 'gallery') {
  const promise = waitForEvent('CAMERA_RESULT', 60000);
  postBridgeMessage('REQUEST_CAMERA', { source });
  return promise;
}

export function share({ title, message, url } = {}) {
  postBridgeMessage('SHARE', { title, message, url });
}

export function openExternalUrl(url) {
  postBridgeMessage('OPEN_EXTERNAL_URL', { url });
}

export function hapticFeedback(type = 'medium') {
  postBridgeMessage('HAPTIC_FEEDBACK', { type });
}

export function copyToClipboard(text) {
  postBridgeMessage('COPY_TO_CLIPBOARD', { text });
}

export function setBadgeCount(count) {
  postBridgeMessage('SET_BADGE_COUNT', { count });
}
